/**
 * Plugin client-side: hidrata o estado de autenticação ao carregar qualquer página.
 * Chama /auth/me com o cookie de sessão para restaurar o usuário logado após reloads.
 */
export default defineNuxtPlugin(async () => {
  const { fetchUser, user } = useAuth()
  const { identifyUser } = useUmami()
  await fetchUser()

  if (user.value) {
    identifyUser(user.value.id, { role: user.value.role })
  }
})
